module.exports = __webpack_public_path__ + "assets/img/left.8ea54071.svg";